import * as React from 'react';
import { cn } from '../../lib/utils';

type ChartContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
};

export function ChartContainer({ className, ...props }: ChartContainerProps) {
  return (
    <div className={cn('w-full h-64', className)} {...props} />
  );
}

type TooltipProps = {
  active?: boolean;
  payload?: any[];
  label?: string;
};

export function ChartTooltip({ children }: { children?: React.ReactNode }) {
  // Acts as a passthrough for Recharts <Tooltip /> component's content prop
  return <>{children}</>;
}

export function ChartTooltipContent({ active, payload, label }: TooltipProps) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="rounded-md border bg-popover px-3 py-2 text-sm text-popover-foreground shadow-sm">
      {label && <div className="mb-1 font-medium">{label}</div>}
      <div className="space-y-0.5">
        {payload.map((p, i) => (
          <div key={i} className="flex items-center justify-between gap-4">
            <span className="text-muted-foreground">{p.name}</span>
            <span className="font-medium">{p.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ChartLegend({ children }: { children?: React.ReactNode }) {
  return <div className="mt-2 flex flex-wrap items-center gap-3">{children}</div>;
}


